// extracted by mini-css-extract-plugin
module.exports = {"order-skeletons":"_1Wcwvkh_fO0IqF1aEkBSd7","order-item":"_3XhcfKjdYk__UcWFoZzG63","skeletons":"_1vTPW8OlYuEqYUuVf-Q9jm","loading":"BrBgiFym4MBLRsHj-DcNr"};